import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { recallNumber } from "../../utils/Number";
import { isValueInChoiceList } from "../../utils";

const maxValueKey = "MaxValue";
const errorKey = "UpperBoundNotFulfilled";

export function maxValue(question, variable) {
    const { name: variableName } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const { settings } = question;
        const { interview } = getState();
        const max = recallNumber(settings[maxValueKey], interview) || Number.MAX_SAFE_INTEGER;

        const mentions = mentionsSelector(getState());
        if (mentions.length) {
            const mentionValue = mentions[0].value;
            const num = recallNumber(mentionValue, interview);
            const isValid = isValueInChoiceList(mentionValue, variable) || num <= max;
            if (!isValid) {
                return { variableName, error: { key: errorKey, args: { max: String(max) } } };
            }
        }
        return null;
    };
}
